import { redirect } from 'redux-first-router'
import {
  validateToken,
  getProspect,
  getJointOwners,
  getFinancialAccounts,
} from 'utils/apiRequest'
import {
  MISSING_ONBOARDING_TOKEN_ERROR,
} from 'utils/errorTypes'
import { onboardingToken, setToken } from 'utils/tokens'
import { handleError } from 'utils/apiErrorHandler'
import {
  prospectIsEmpty,
  financialAccountsIsEmpty
} from 'utils/storeUtils'
import {
  SCHWAB_ONE_PERSONAL,
  SCHWAB_ONE_TRUST,
  SCHWAB_IRA,
  SCHWAB_CHARITABLE,
} from 'utils/financialAccountTypes'
import { setBugsnagUser } from 'bugsnag'
import actions from 'actions/index'
import {
  handleContactsPageRequests,
  handleAddContactPageRequests,
  handleEditContactPageRequests
} from 'routing/thunks/handlers/onboarding'

const {
  goOnboardingGettingStarted,
  goErrorPage,
  goSecureDocumentUploaderPage,
  setFinancialAccounts,
  setFinancialAccountCollapsed,
  setsidebarDataLoaded,
  setJointAccounts,
  setProspect,
  closeNav,
  setError,
  setIsLoading,
  setAppType
} = actions

const getAccountsForType = (accounts, type) => (
  accounts.filter(account => (
    account.attributes.financialAccountType === type
  ))
)

/* Navigation handlers */

export const onBeforeChangeOnboarding = async (dispatch) => {
  dispatch(setAppType('onboarding'))

  if (!onboardingToken()) {
    dispatch(setError(MISSING_ONBOARDING_TOKEN_ERROR))
    dispatch(redirect(goErrorPage()))
  }
}

export const onBeforeChangeSecureDocUploader = async (dispatch) => {}

/* Onboarding */

export const setOnboardingToken = async (dispatch, getState) => {
  const { location: { type, payload: { token } } } = getState()
  const feature = type.toLowerCase()
  try {
    await validateToken(token, feature)
    setToken('onboardingToken', token)
    dispatch(redirect(goOnboardingGettingStarted()))
  } catch (e) {
    handleError(e)
  }
}

export const handleJointAccountOwner = async (dispatch, getState) => {
  const {
    location: {
      payload: {
        financialAccountId
      }
    }
  } = getState()

  const callback = async () => {
    const jointOwnersInfo = await getJointOwners(financialAccountId)
    dispatch(setJointAccounts({ jointOwnersInfo, financialAccountId }))
  }
  await handleFinancialAccount(dispatch, getState, null, callback)
}

export const handleAccountHolder = async (dispatch, getState, action, callback) => {
  const {
    prospect,
    financialAccounts
  } = getState()
  dispatch(setIsLoading(true))
  dispatch(closeNav())
  try {
    if (prospectIsEmpty(prospect)) {
      const prospectData = await getProspect()
      const {
        data: {
          id,
          attributes: {
            canonicalUserId,
            onboardingFinancialAccountsVisible
          }
        }
      } = prospectData
      setBugsnagUser(id, canonicalUserId)
      dispatch(setProspect(prospectData))

      if (onboardingFinancialAccountsVisible && financialAccountsIsEmpty(financialAccounts)) {
        await loadFinancialAccounts(dispatch, prospectData)
      }
    }
    dispatch(setsidebarDataLoaded(true))
    if (callback) await callback()
    dispatch(setIsLoading(false))
    return true
  } catch (e) {
    handleError(e)
    return false
  }
}

export const handleContactsPage = async (dispatch, getState) => {
  const callback = async () => {
    await handleContactsPageRequests(dispatch, getState)
  }
  await handleFinancialAccount(dispatch, getState, null, callback)
}

export const handleAddContactPage = async (dispatch, getState) => {
  const callback = async () => {
    await handleAddContactPageRequests(dispatch, getState)
  }
  await handleFinancialAccount(dispatch, getState, null, callback)
}

export const handleEditContactPage = async (dispatch, getState) => {
  const callback = async () => {
    await handleEditContactPageRequests(dispatch, getState)
    const {
      location: { payload: { contactId } },
      contacts: { contacts }
    } = getState()
    if (contactId && !contacts.find(contact => (contact.id === contactId))) {
      return dispatch(redirect(goErrorPage()))
    }
  }

  await handleFinancialAccount(dispatch, getState, null, callback)
}

export const handleFinancialAccount = async (dispatch, getState, action, callback) => {
  const {
    location: {
      payload: {
        financialAccountId,
      }
    }
  } = getState()
  const success = await handleAccountHolder(dispatch, getState, null, callback)

  if (success) {
    const { financialAccounts: { financialAccounts } } = getState()
    const found = financialAccounts.find(account => account.id === financialAccountId)

    if (found) {
      dispatch(setFinancialAccountCollapsed(financialAccountId, false))
    }
  } else {
    dispatch(redirect(goErrorPage()))
  }
}

const loadFinancialAccounts = async (dispatch, data) => {
  const financialAccountVisible = data.data.attributes.onboardingFinancialAccountsVisible

  if (financialAccountVisible) {
    const accounts = await getFinancialAccounts()
    const schwabPersonalAccounts = getAccountsForType(accounts.data, SCHWAB_ONE_PERSONAL.RAW_TYPE)
    const schwabTrustAccounts = getAccountsForType(accounts.data, SCHWAB_ONE_TRUST.RAW_TYPE)
    const schwabIRAAccounts = getAccountsForType(accounts.data, SCHWAB_IRA.RAW_TYPE)
    const charitableAccounts = getAccountsForType(accounts.data, SCHWAB_CHARITABLE.RAW_TYPE)

    const orderedAccounts = [
      ...schwabPersonalAccounts,
      ...schwabTrustAccounts,
      ...schwabIRAAccounts,
      ...charitableAccounts,
    ]
    dispatch(setFinancialAccounts(orderedAccounts))
  }
}

export const handleConfirmation = (dispatch, getState) => {
  dispatch(closeNav())
}

/* Secure Doc Uploader */

export const setSecureDocUploaderToken = async (dispatch, getState) => {
  const { location: { type, payload: { token } } } = getState()
  const feature = type.toLowerCase()

  try {
    await validateToken(token, feature)
    setToken('secureDocUploaderToken', token)
    dispatch(redirect(goSecureDocumentUploaderPage()))
  } catch (e) {
    handleError(e)
  }
}



// WEBPACK FOOTER //
// ./src/routing/thunks/onboarding.js